import usePostHogIdentify from 'utils/hooks/use-posthog-identify/usePostHogIdentify'

const PostHogInitializer = () => {
  usePostHogIdentify()

  return null
}

export default PostHogInitializer
